import { render, staticRenderFns } from "./DiabetesGroup.vue?vue&type=template&id=627b0706&scoped=true&"
import script from "./DiabetesGroup.vue?vue&type=script&lang=js&"
export * from "./DiabetesGroup.vue?vue&type=script&lang=js&"
import style0 from "./DiabetesGroup.vue?vue&type=style&index=0&id=627b0706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b0706",
  null
  
)

export default component.exports